import { IKBSearchResult } from '../../types/KB/IKBSearchResult';
import { IKBItem, ILinkedKB } from '../../types/KB/ILinkedKB';
import { KBSearchProps } from '../../types/KB/KBSearchProps';
import { Api } from './BaseApi'

const KBApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getTicketKbs: build.query<IKBItem[], number>({
            query: (id) => `KB/Ticket/${id}`,
            providesTags: ["GetTicketKBs"],
        }),
        updateLinkedKbs: build.mutation<void, { ticketId: number, items: ILinkedKB[] }>({
            query: (info) => ({
                url: `KB/Ticket/${info.ticketId}`,
                method: "POST",
                body: info.items,
            }),
            invalidatesTags: ["KBSearch", "GetActions", "GetTicketKBs"]
        }),
        searchKB: build.mutation<IKBSearchResult[] | number, KBSearchProps>({
            query: (info) => ({
                url: "KB/Search/",
                method: "POST",
                body: info,
            }),
            invalidatesTags: ["KBSearch"]
        }),
    }),
    overrideExisting: false,
})

export { KBApi };